module.exports = __webpack_public_path__ + "static/media/borderlands3.6dc3b5ab.jpg";